import { render, staticRenderFns } from "./WaterLeakageCauseFixedQuestion.vue?vue&type=template&id=74076ba8&scoped=true"
import script from "./WaterLeakageCauseFixedQuestion.vue?vue&type=script&lang=ts"
export * from "./WaterLeakageCauseFixedQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74076ba8",
  null
  
)

export default component.exports